import { render, staticRenderFns } from "./ComponentSnippet.vue?vue&type=template&id=b499d4b6&"
import script from "./ComponentSnippet.vue?vue&type=script&lang=js&"
export * from "./ComponentSnippet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports